(function () {
  'use strict';

  // A higher-density Shopify CDN variant may fail while the smaller variant is available.
  // Retry once with the base image for dynamically replaced collection/search grids too.
  document.addEventListener('error', function (event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG' || img.dataset.carderiaImageRetry) return;
    if (!img.closest('#CollectionProducts, #SearchResultsGrid')) return;

    img.dataset.carderiaImageRetry = '1';
    var master = img.getAttribute('data-master');
    var fallback = master ? master.replace('{width}', '300') : img.getAttribute('src');
    if (!fallback) return;
    img.removeAttribute('srcset');
    img.setAttribute('src', fallback);
  }, true);
})();
